import {DiscountType} from "../../libs/enum/discount-type";

export class ReceiptDiscountDto {

  public readonly id!: string;
  public readonly type!: DiscountType;
  public readonly value!: number;
  public readonly netAmount!: number;
  public readonly grossAmount!: number;
  public readonly vatAmount!: number;
  public readonly totalNetAmount!: number;
  public readonly totalGrossAmount!: number;
  public readonly totalVatAmount!: number;

  constructor(init?: Partial<ReceiptDiscountDto> | undefined) {
    Object.assign(this, init);
  }
}
